import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';

@Injectable({
  providedIn: 'root'
})
export class AmsNotifierService {
  constructor() { }

  success(message: string) {
    notify(message, 'success', 2000);
  }

  info(message: string) {
    notify(message, 'info', 2000);
  }

  warning(message: string) {
    var widgetOptions = {
      closeOnClick: true,
      message: message
    };
    notify(widgetOptions, 'warning', 30000);
  }

  warningWithTimeout(message: string) {
    notify(message, 'warning', 2000);
  }

  error(message: string) {
    var widgetOptions = {
      closeOnClick: true,
      message: message
    };
    notify(widgetOptions, 'error', 30000);
  }

  errorWithTimeout(message: string) {
    this.error(message);
    // notify(message, 'error', 5000);
  }

  errorWithForcedTimeout(message: string, timeout: number = 5000) {
    notify(message, 'error', timeout);
  }

}
